// Stable values also label existing documents; categories only organize the menu.
export const DOCUMENT_TYPES = [
  { value: 'PASSPORT', label: 'Passport', category: 'Identity & travel' },
  { value: 'IDENTITY_CARD', label: 'Identity card', category: 'Identity & travel' },
  { value: 'DRIVERS_LICENSE', label: "Driver’s license", category: 'Identity & travel' },
  { value: 'VISA', label: 'Visa / residency permit', category: 'Identity & travel' },
  { value: 'PROFESSIONAL_LICENSE', label: 'Professional license', category: 'Professional & employment' },
  { value: 'CERTIFICATION', label: 'Certification / training', category: 'Professional & employment' },
  { value: 'WORK_PERMIT', label: 'Work permit', category: 'Professional & employment' },
  { value: 'EMPLOYMENT_AGREEMENT', label: 'Employment agreement', category: 'Professional & employment' },
  { value: 'BACKGROUND_CHECK', label: 'Background check', category: 'Professional & employment' },
  { value: 'LICENSE', label: 'License / business permit', category: 'Business & legal' },
  { value: 'BUSINESS_REGISTRATION', label: 'Business registration', category: 'Business & legal' },
  { value: 'INSURANCE', label: 'Insurance', category: 'Business & legal' },
  { value: 'CONTRACT', label: 'Contract / agreement', category: 'Business & legal' },
  { value: 'LEASE', label: 'Lease', category: 'Business & legal' },
  { value: 'POLICY', label: 'Policy', category: 'Business & legal' },
  { value: 'COMPLIANCE', label: 'Compliance / inspection', category: 'Business & legal' },
  { value: 'TAX_DOCUMENT', label: 'Tax document', category: 'Business & legal' },
  { value: 'CPR', label: 'CPR certification', category: 'Health & safety' },
  { value: 'FOOD_HANDLER', label: 'Food handler permit', category: 'Health & safety' },
  { value: 'CNA_LICENSE', label: 'CNA license', category: 'Health & safety' },
  { value: 'TB_TEST', label: 'TB test', category: 'Health & safety' },
  { value: 'N95_FIT', label: 'N95 fit test', category: 'Health & safety' },
  { value: 'OTHER', label: 'Other / custom', category: 'Other' },
];

export const DOCUMENT_TYPE_LABELS = Object.fromEntries(DOCUMENT_TYPES.map(type => [type.value, type.label]));
